import React, { Component, Fragment } from "react";
import api from "../../../../../services/api"
import utils from "../../../../../utils/utils";

export default class NovoForm extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    async componentDidMount() {
        //await this.consultarMetasMensaisSTI();
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.categoriaSelecionada !== this.state.categoriaSelecionada) {
            //await this.consultarMetasMensaisSTI();
        }
    }

    totalAno = (serie) => {
        return serie.reduce((acc, atual) => acc + atual, 0);
    }

    render() {
        let { soma, indicadoresnome, unidade } = this.props;
        return (
            <Fragment>
                <div className="row pr-3 pl-3">
                    <div className="col-md-12 ml-auto mr-auto">
                        <div className="card card-user">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h6 className="text-uppercase m-2 text-center">{unidade}</h6>
                                        <div className="table table-striped table-hover table-borderless table-sm table-responsive">
                                            <table className="text-center">
                                                <thead>
                                                    <tr>
                                                    <th>Indicador</th>
                                                    <th scope="col">Total</th>
                                                    <th scope="col">Jan</th>
                                                    <th scope="col">Fev</th>
                                                    <th scope="col">Mar</th>
                                                    <th scope="col">Abr</th>
                                                    <th scope="col">Mai</th>
                                                    <th scope="col">Jun</th>
                                                    <th scope="col">Jul</th>
                                                    <th scope="col">Ago</th>
                                                    <th scope="col">Set</th>
                                                    <th scope="col">Out</th>
                                                    <th scope="col">Nov</th>
                                                    <th scope="col">Dez</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.keys(soma || {}).map((indicador, key) => {
                                                        if(indicador === "despesa" || indicador === "receita") return;
                                                        return (
                                                            [5, 6].includes(key) ?

                                                                <tr key={key}>
                                                                    <th scope="row" className="text-center">{indicadoresnome[key]}</th>
                                                                    <td scope="col">{utils.formataValorMoeda(this.totalAno(soma[indicador]))}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][0])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][1])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][2])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][3])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][4])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][5])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][6])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][7])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][8])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][9])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][10])}</td>
                                                                    <td scope="col">{utils.formataValorMoeda(soma[indicador][11])}</td>
                                                                </tr>
                                                            :
                                                                <tr key={key}>
                                                                    <th scope="row" className="text-center">{indicadoresnome[key]}</th>
                                                                    <td scope="col">{utils.formataValor(this.totalAno(soma[indicador]))}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][0])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][1])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][2])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][3])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][4])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][5])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][6])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][7])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][8])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][9])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][10])}</td>
                                                                    <td scope="col">{utils.formataValor(soma[indicador][11])}</td>
                                                                </tr>
                                                        )

                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}